import React, { useEffect } from 'react'
import { Form, FormControl } from 'react-bootstrap'

const EditDescription = ({
    value = '',
    onChange = () => {}
}) => {
    useEffect(() => {
        if (value && value.length > 254) {
            onChange(value.substring(0, 254))
        }
    }, [value, onChange])

    return (
        <Form.Group>
            <FormControl
                as="textarea" rows={2}
                placeholder='Experience description'
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </Form.Group>
    )
}

export default EditDescription